
import Vue from "vue";
import { showOkCancelDialog } from "@/lib/dialog";
import FolderOutlineIcon from "icons/FolderOutline.vue";
import EqualIcon from "icons/Equal.vue";
import DotsHorizontalIcon from "icons/DotsHorizontal.vue";
import CheckboxIcon from "@/components/atoms/CheckboxIcon.vue";
import ClickOutside from "vue-click-outside";

export default Vue.extend<Data, Methods, Computed, Props>({
  directives: { ClickOutside },
  components: {
    FolderOutlineIcon,
    EqualIcon,
    DotsHorizontalIcon,
    CheckboxIcon,
  },
  props: {
    label: String,
    count: Number,
    onSelectCallback: Function,
    isSorting: Boolean,
    isSelecting: Boolean,
    item: Object,
    onCheckCallback: Function,
    isChecked: Boolean,
    onRenameCallback: Function,
    onDeleteCallback: Function,
    disabledMenu: Boolean,
  },
  data() {
    return {
      isShowMenu: false,
      themeWatcher: null as MutationObserver | null,
    };
  },
  created() {
    // テーマ変更を検知するMutationObserverを設定
    if (typeof window !== "undefined") {
      this.themeWatcher = new MutationObserver(() => {
        this.$forceUpdate();
      });
      this.themeWatcher.observe(document.documentElement, {
        attributes: true,
        attributeFilter: ["data-app-theme"],
      });
    }
  },
  beforeDestroy() {
    if (this.themeWatcher) {
      this.themeWatcher.disconnect();
      this.themeWatcher = null;
    }
  },
  computed: {
    iconColor() {
      if (typeof document === "undefined") return "#787878";
      const theme = document.documentElement.getAttribute("data-app-theme");
      return theme === "dark" ? "#e0e0e0" : "#787878";
    },
    checkBoxColor() {
      if (typeof document === "undefined") return "#707070";
      const theme = document.documentElement.getAttribute("data-app-theme");
      return theme === "dark" ? "#e0e0e0" : "#707070";
    },
  },
  methods: {
    async click() {
      if (this.isSorting) {
        return;
      }

      if (this.isSelecting) {
        this.onCheckCallback();
        return;
      }

      if (this.isModified()) {
        const yes = await showOkCancelDialog({
          title: this.$t('manuscriptPage.listFolderItem.confirmDialog.title') as string,
          content: this.$t('manuscriptPage.listFolderItem.confirmDialog.content') as string,
          okButton: this.$t('manuscriptPage.listFolderItem.confirmDialog.okButton') as string,
          cancelButton: this.$t('manuscriptPage.listFolderItem.confirmDialog.cancelButton') as string,
        });
        if (!yes) {
          return;
        }
      }

      this.setModified(false);
      this.onSelectCallback();
    },
    rename() {
      this.onRenameCallback();
    },
    deleteItem() {
      this.onDeleteCallback();
    },
    onClickMenu() {
      this.isShowMenu = true;
    },
    closeMenu() {
      this.isShowMenu = false;
    },
  },
});

interface Props {
  label: string;
  count: number;
  onSelectCallback: void;
  isSorting: boolean;
  isSelecting: boolean;
  item: object;
  onCheckCallback: void;
  isChecked: boolean;
  onRenameCallback: void;
  onDeleteCallback: void;
  disabledMenu: boolean;
}

interface Data {
  isShowMenu: boolean;
  themeWatcher: MutationObserver | null;
}

interface Computed {
  iconColor: string;
  checkBoxColor: string;
}

interface Methods {
  click(): Promise<void>;
  rename(): void;
  deleteItem(): void;
  onClickMenu(): void;
  closeMenu(): void;
}
